import { h } from 'preact'
import ButtonControl from '../button-control'

interface Props {
  id: number
  title: string
  onDelete: (id: number, title: string) => void
}

const BadgeActions = ({ id, title, onDelete }: Props) => {
  return (
    <div style='white-space:nowrap'>
      <a href={`/settings/badge/edit/${id}`}><ButtonControl title='Edit' newStyle /></a>
      <ButtonControl title='Delete' newStyle variant='warning' onClick={() => onDelete(id, title)} />
    </div>
  )
}

export default BadgeActions
